/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { Project } from "types";

type Response = {
  payload: Project[];
};

export function useProjectList() {
  const api = useApi();
  const [data, setData] = useState<Project[]>([]);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);

    api
      .get("/project/")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? [];
        console.log(data);
        setData(data);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(false);
    };
  }, []);

  return {
    data,
    isLoading,
    refetch,
    dropdown: data.map((item) => ({
      label: item.project_name,
      value: item.project_id.toString()
    }))
  };
}
